import * as React from 'react'

import { Box, Button, ButtonBase } from '@material-ui/core'

import { MarketplaceMediaDetailModal } from './MarketplaceMediaDetailModal'

interface IMarketplaceMediaUploadButtonProps {
  marketplaceListingId: string | null
  previewUrl?: string | null
  onUpload?: (imageUrl: string) => void
  aspectRatio?: number
  isNote?: boolean
}

type MarketplaceMediaUploadButtonProps = IMarketplaceMediaUploadButtonProps

export const MarketplaceMediaUploadButton: React.FC<MarketplaceMediaUploadButtonProps> = props => {
  const [modalOpen, setModalOpen] = React.useState(false)
  const [previewUrl, setPreviewUrl] = React.useState('')

  React.useEffect(() => {
    if (!previewUrl) {
      setPreviewUrl(props.previewUrl ?? '')
    }
  }, [previewUrl, setPreviewUrl, props])

  return (
    <>
      <MarketplaceMediaDetailModal
        marketplaceListingId={props.marketplaceListingId}
        open={modalOpen}
        aspectRatio={props.aspectRatio}
        isNote={props.isNote}
        onClose={() => setModalOpen(false)}
        onSave={(imageUrl: string) => {
          setModalOpen(false)
          setPreviewUrl(imageUrl)
          props.onUpload?.(imageUrl)
        }}
      />
      <Box>
        <ButtonBase onClick={() => setModalOpen(true)}>
          {previewUrl ? (
            <img style={{ maxHeight: 200 }} src={previewUrl} alt='preview' />
          ) : (
            <Button variant='outlined'>Upload</Button>
          )}
        </ButtonBase>
      </Box>
    </>
  )
}
